import { useCallback } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useRestaurantContext } from "@/contexts/RestaurantContext";
import { toast } from "sonner";

export function usePDVOperatorSettings() {
  const { activeRestaurant, refetch } = useRestaurantContext();

  const requireOperatorLogin = (activeRestaurant as any)?.pdv_require_operator_login ?? false;

  const updateRequireOperatorLogin = useCallback(
    async (enabled: boolean) => {
      if (!activeRestaurant) return;
      const { error } = await supabase
        .from("restaurants")
        .update({ pdv_require_operator_login: enabled } as any)
        .eq("id", activeRestaurant.id);

      if (error) {
        toast.error("Erro ao salvar configuração");
        console.error(error);
        return;
      }
      toast.success(enabled ? "Login de operador ativado" : "Login de operador desativado");
      await refetch();
    },
    [activeRestaurant, refetch]
  );

  return { requireOperatorLogin, updateRequireOperatorLogin };
}
